// extracted by mini-css-extract-plugin
module.exports = {"items":"items_items__2bvGb","flex":"items_flex__8VB3S","text":"items_text__32XlU","image":"items_image__2ZaVk"};